import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(ICategoryTreeNodeMetadata) {
    (function(CategoryGroup) {
        CategoryGroup["CATEGORY_GROUP_UNKNOWN"] = "CATEGORY_GROUP_UNKNOWN";
        CategoryGroup["APPAREL"] = "APPAREL";
        CategoryGroup["ACCESSORIES"] = "ACCESSORIES";
        CategoryGroup["FOOD_AND_BEVERAGE"] = "FOOD_AND_BEVERAGE";
        CategoryGroup["OTHER_CATEGORY"] = "OTHER_CATEGORY";
        CategoryGroup["HUB"] = "HUB";
        /**
     * @deprecated
     */ CategoryGroup["SDUI_HUB"] = "SDUI_HUB";
        CategoryGroup["DIGEST_PAGE"] = "DIGEST_PAGE";
    })(ICategoryTreeNodeMetadata.CategoryGroup || (ICategoryTreeNodeMetadata.CategoryGroup = {}));
    ICategoryTreeNodeMetadata.build = function(partial) {
        return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
    };
})(ICategoryTreeNodeMetadata || (ICategoryTreeNodeMetadata = {}));
export var ICategoryTreeNodeMetadata;
